import React, { Component } from "react";
import { Col, Card, Row, Button } from "react-bootstrap";
import RepairServices from "./images/newImages/Depot Electronics.jpg";
import TechSupport from "./images/techSupport.JPG";
import MotorShield from "./images/Genius_614_No_Background_Shadow_Added.png";
import CleaningService from "./images/RevisedImages/CalibrationLabUnstretched.jpg";
import SurdialDXAlt from "./images/SURDIAL_DX_Training_Mathew_Group_Edited_10152024_Cropped.jpg";
import Manufacturing from "./images/Manufacturing.jpg";
import CardioQuip from "./images/hsm-revisions/Quality.jpg";
import SURDIALDXHemodialysisSystemTreatment from "./images/surdialDX/SURDIALDXHemodialysisSystemTreatment.jpg";
//this is actually the landing cards for mobile

class LandingCards extends Component {
  render() {
    return (
      <Col sm={12} xl={12}>
        <Row className="equal">
          <Col sm={12} md={4} lg={4} className="LandingCardsCol" >
            <Card className="landingCardsMobile" style={{ width: "18rem" }}>
              <Card.Img src={RepairServices} className="img-responsive" />
              <Card.Body>
                <Card.Title>Hemodialysis Parts Service Center</Card.Title>
                <Card.Text>
                  NIPRO Technical Solutions offers a quick turnaround
                  time along with our signature 6-month, hassle-free warranty
                  policy for all services.
                </Card.Text>
                <Button variant="custom" href="/services" >
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col sm={12} md={4} lg={4} className="LandingCardsCol">
            <Card className="landingCardsMobile" style={{ width: "18rem" }}>
              <Card.Img src={CleaningService} className="img-responsive" />
              <Card.Body>
                <Card.Title>
                  Calibration Service Center & Reference Meters
                </Card.Title>
                <Card.Text>
 NIPRO Technical Solutions' full-service calibration center provides verification 
 and repair services for a wide range of multimeters, safety analyzers, and biomedical reference meters.
                </Card.Text>
                <Button variant="custom" href="/meters-calibration" >
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col sm={12} md={4} lg={4} className="LandingCardsCol">
            <Card className="landingCardsMobile" style={{ width: "18rem" }}>
              <Card.Img src={MotorShield} className="img-responsive" />
              <Card.Body>
                <Card.Title>
                  Biomedical Technician
                  Assist Devices{" "}
                </Card.Title>
                <Card.Text>
                NIPRO Technical Solutions is dedicated to helping
                  biomed technicians through innovative products such as the
                  Genius 614 Valve & Chamber Analyzer, BTA-612 Selectable
                  Voltage Power Supply, Motor Shields & Valve Repair Kits.
                </Card.Text>
                <Button href="/products" variant="custom">
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="equal" id="equalRow">
          <Col sm={12} md={4} lg={4} className="LandingCardsCol ">
            <Card className="landingCardsMobile" style={{ width: "18rem" }}>
              <Card.Img src={TechSupport} className="img-responsive" />
              <Card.Body>
                <Card.Title>Technical Support</Card.Title>
                <Card.Text>
                  Speak with a highly skilled Technical Support expert to answer
                  all your troubleshooting questions. All calls are answered by
                  our friendly customer service representatives.
                </Card.Text>
                <Button href="/technical-support" variant="custom">
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col sm={12} md={4} lg={4} className="LandingCardsCol">
            <Card className="landingCardsMobile" style={{ width: "18rem" }}>
              <Card.Img src={SurdialDXAlt} className="img-responsive" />
              <Card.Body>
                <Card.Title>Field Service Engineering</Card.Title>
                <Card.Text>
                      NIPRO Technical Solutions performs repairs, annual maintenance, 
                      and expert support for all major U.S. brands of hemodialysis machines. {" "}
                </Card.Text>
                <Button href="/field-service-engineering" variant="custom">
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
                    <Col sm={12} md={4} lg={4} className="LandingCardsCol">
            <Card className="landingCardsMobile" style={{ width: "18rem" }}>
              <Card.Img src={SURDIALDXHemodialysisSystemTreatment} className="img-responsive" />
              <Card.Body>
                <Card.Title>SURDIAL™ DX Hemodialysis System</Card.Title>
                <Card.Text>
The SURDIAL™ DX Hemodialysis System was inspired by clinical needs, patient comfort, and operational efficiency. 
Its innovative design takes both the patient and clinician experience to a different level.
                </Card.Text>
                <Button href="surdialDX" variant="custom">
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="equal" id="equalRow">
            <Col sm={12} md={4} lg={4} className="LandingCardsCol">
            <Card className="landingCardsMobile" style={{ width: "18rem" }}>
              <Card.Img src={Manufacturing} className="img-responsive" />
              <Card.Body>
                <Card.Title>Manufacturing Services</Card.Title>
                <Card.Text>
                Our Manufacturing Service Center provides dedicated and customizable manufacturing services
                 for the global medical community.
                </Card.Text>
                <Button href="manufacturing/manufacturing-services" variant="custom">
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col sm={12} md={4} lg={4} className="LandingCardsCol">
            <Card className="landingCardsMobile" style={{ width: "18rem" }}>
              <Card.Img src={CardioQuip} className="img-responsive" />
              <Card.Body>
                <Card.Title>
                  Quality
                  Systems
                </Card.Title>
                <Card.Text>
                  At NIPRO Technical Solutions, quality
                  is ingrained into who we are. Let us use our over 25 years of
                  experience to seamlessly develop a quality system for you.  
                </Card.Text>
                <Button href="/quality-systems" variant="custom">
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
    );
  }
}

export default LandingCards;
